import { useState } from 'react';

const EventServiceCheckbox = ({ eventService, onChange }) => {

    const [isChecked, setIsChecked] = useState(eventService.active)

    const checkHandler = () => {
        const newCheckedState = !isChecked;
        setIsChecked(newCheckedState);
        if (onChange) {
            onChange(eventService.value, newCheckedState);
        }
    };

    const getActiveClass = () => {
        return isChecked ? 'active' : '';
    }

    return (
        <div className={`event-service ${getActiveClass()} flex-fill`}>
            <input
                id={eventService.value}                
                type="checkbox"
                className="d-none"
                checked={isChecked}
                readOnly
            />
            <label
                htmlFor={eventService.value}                
                className='d-flex flex-column justify-content-center align-items-center'
                onClick={checkHandler}
            >
                <div className={`event-service-checkbox-icon ${getActiveClass()}`}>{eventService.svg()}</div>
                <div className={`event-service-checkbox-label ${getActiveClass()}`}>{eventService.label}</div>
            </label>
        </div>
    );
};

export default EventServiceCheckbox;
